// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UAFunctionalState = {
    Aborted: 'aborted',
    Aborting: 'aborting',
    Clearing: 'clearing',
    Stopped: 'stopped',
    Running: 'running',
    Stopping: 'stopping'
} as const;
export type UAFunctionalState = typeof UAFunctionalState[keyof typeof UAFunctionalState];


export function instanceOfUAFunctionalState(value: any): boolean {
    for (const key in UAFunctionalState) {
        if (Object.prototype.hasOwnProperty.call(UAFunctionalState, key)) {
            if (UAFunctionalState[key as keyof typeof UAFunctionalState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UAFunctionalStateFromJSON(json: any): UAFunctionalState {
    return UAFunctionalStateFromJSONTyped(json, false);
}

export function UAFunctionalStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAFunctionalState {
    return json as UAFunctionalState;
}

export function UAFunctionalStateToJSON(value?: UAFunctionalState | null): any {
    return value as any;
}

export function UAFunctionalStateToJSONTyped(value: any, ignoreDiscriminator: boolean): UAFunctionalState {
    return value as UAFunctionalState;
}

